export default __webpack_public_path__ + "static/N0319-c7cafb68b165a48e48590b9610435116.png";